import type { V2CurrentPositionLike } from '@/map/operational/v2-current-positions-markers';
import { formatCurrentPositionPopup } from '@/utils/current-position-popup';

/** HTML popup for a single / expanded convoy device pin. */
export function namedSinglePopupHtml(
  label: string,
  row: V2CurrentPositionLike | undefined,
  expanded: boolean,
  exceptionTitles: readonly string[] = [],
): string {
  return formatCurrentPositionPopup({
    label,
    address: row?.address,
    location: row?.location,
    timestampSec: row?.timestamp,
    battery: row?.battery,
    fix: row?.fix,
    accuracyMeters: row?.accuracy,
    exceptionTitles,
    expandedHint: expanded,
  });
}
